const baseURL = "https://backend-stg.myclnq.co.za/";      //STAGE
// const baseURL = "https://backend-preprod.fvhospital.com/";      //PRE-PROD
// const baseURL = "https://backend.fvhospital.com/";      //PRODUCTION



// const azureRedirect = "http://localhost:3000/"    //LOCAL
const azureRedirect = "https://myclnq.co/stage/fv-provider/"     //STAGE
// const azureRedirect = "https://provider-preprod.fvhospital.com/"     //PRE-PROD
// const azureRedirect = "https://provider.fvhospital.com/"     //PRODUCTION

const tAndC = "";
const apiName = {
  getTranslationLanguage: "clinic/language/string/details",
};

const googleConfig = {
  googlePlacesAutocomplete_APIKey: "AIzaSyCgfatIwA6Tdw3ZhAyDzoLkG0b_kk4i8Qw", //"AIzaSyAMmuNHa5-ezxIMPuTWxhMPsrjc2Irdygw",
};

const config = {
  baseURL,
  azureRedirect,
  tAndC,
  apiName,
  googleConfig
};

export default config;
